import http, { request } from "@config/http";
import { Page, List } from "@services/common/model/page.model";
import type { ResponseType, AxiosProgressEvent } from "axios";
import { FileContentTypeEnum } from "./enum/common.enum";
import {
  IdNameModel,
  BatchSeqInfoParamsModel,
  SeqInfoModel,
} from "./model/gloabal.model";

export const uploadFileApi = async (formData: FormData) => {
  return http.post<null, Page<string>>(`files`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

type FileResult<T> = T extends "text"
  ? string
  : T extends "blob"
  ? Blob
  : never;

export const downloadFileApi = <T extends ResponseType>(
  fids: string[],
  responseType: T,
  onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  return request.post<null, FileResult<T>>(
    `lite/file/download_file`,
    { fids },
    {
      responseType: responseType,
      onDownloadProgress: (progressEvent) => {
        if (onDownloadProgress) {
          onDownloadProgress(progressEvent);
        }
      },
    }
  );
};

export const batchGetFileInfoApi = async (
  file_ids: string[],
  view_type: string
) => {
  const { data } = await http.post<null, Page<List<IdNameModel>>>(
    `lite/file/batch_get_file_info`,
    {
      file_ids,
      view_type,
    }
  );

  return data.list;
};

export const batchGetSeqInfoApi = async (params: BatchSeqInfoParamsModel) => {
  const data = await request.post<null, Page<List<SeqInfoModel>>>(
    `lite/util/batch_seq_info`,
    {
      ...params,
    }
  );

  return data;
};
